import request from "./http.js";  //导入封装请求的js文件
export function home(data) {
    return request({
      url: "/front.Front/front",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function system(data) {
    return request({
      url: "/front.Front/system",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function address_list(data) {
    return request({
      url: "/front.About/address_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function history_list(data) {
    return request({
      url: "/front.About/history_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function team_list(data) {
    return request({
      url: "/front.About/team_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function contact_list(data) {
    return request({
      url: "/front.About/contact_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function feedback(data) {
    return request({
      url: "/front.About/feedback",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function article_list(data) {
    return request({
      url: "/front.Article/article_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function article_details(data) {
    return request({
      url: "/front.Article/article_details",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function show(data) {
    return request({
      url: "/front.JoinUs/show",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function apply(data) {
    return request({
      url: "/front.JoinUs/apply",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function join_us(data) {
    return request({
      url: "/front.JoinUs/join_us",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function code(data) {
    return request({
      url: "/user.Login/code",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function login_code(data) {
    return request({
      url: "/user.Login/login_code",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function cate_list(data) {
    return request({
      url: "/front.Front/cate_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }

  export function goods_list(data) {
    return request({
      url: "/user.Goods/goods_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function goods_details(data) {
    return request({
      url: "/user.Goods/goods_details",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function hot_search(data) {
    return request({
      url: "/front.Front/hot_search",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function incvoice(data) {
    return request({
      url: "/order.Order/incvoice",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function incvoice_edit(data) {
    return request({
      url: "/order.Order/incvoice_edit",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function order_details(data) {
    return request({
      url: "/order.Order/order_details",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function order_edit(data) {
    return request({
      url: "/order.Order/order_edit",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function product_list(data) {
    return request({
      url: "/product.Product/product_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function product_details(data) {
    return request({
      url: "/product.Product/product_details",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function certificate(data) {
    return request({
      url: "/product.Product/certificate",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function search(data) {
    return request({
      url: "/product.Product/search",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function login(data) {
    return request({
      url: "/user.Login/login",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function regist(data) {
    return request({
      url: "/user.Login/regist",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function user_info(data) {
    return request({
      url: "/user.User/user_info",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function edit(data) {
    return request({
      url: "/user.User/edit_info",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function order_del(data) {
    return request({
      url: "order.Order/order_del",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function cust_add(data) {
    return request({
      url: "front.Cust/cust_add",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }

  export function order_del2(data) {
    return request({
      url: "user.ExchangeOrder/order_del",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function order_list2(data) {
    return request({
      url: "user.ExchangeOrder/order_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function refun(data) {
    return request({
      url: "/order.RefunOrder/refun",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function message_add(data) {
    return request({
      url: "/order.Order/message_add",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function order_list(data) {
    return request({
      url: "/order.Order/order_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function get_list(data) {
    return request({
      url: "/user.UserAddress/get_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function get_details(data) {
    return request({
      url: "/user.UserAddress/get_details",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function add_address(data) {
    return request({
      url: "/user.UserAddress/add_address",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function edit_address(data) {
    return request({
      url: "/user.UserAddress/edit_address",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function header_add(data) {
    return request({
      url: "/user.InvoiceHeader/header_add",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function header_list(data) {
    return request({
      url: "/user.InvoiceHeader/header_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function integral_list(data) {
    return request({
      url: "/user.UserIntegral/integral_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function header_details(data) {
    return request({
      url: "/user.InvoiceHeader/header_details",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function header_del(data) {
    return request({
      url: "/user.InvoiceHeader/header_del",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  
  export function header_edit(data) {
    return request({
      url: "/user.InvoiceHeader/header_edit",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function del_address(data) {
    return request({
      url: "/user.UserAddress/del_address",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function collect_list(data) {
    return request({
      url: "/user.UserCollect/collect_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function collect_add(data) {
    return request({
      url: "/user.UserCollect/collect_add",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }

  export function collect_del(data) {
    return request({
      url: "/user.UserCollect/collect_del",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function cart_add(data) {
    return request({
      url: "/product.ShoppingCart/cart_add",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function cart_list(data) {
    return request({
      url: "/product.ShoppingCart/cart_list",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function cart_del(data) {
    return request({
      url: "/product.ShoppingCart/cart_del",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function cart_edit(data) {
    return request({
      url: "/product.ShoppingCart/cart_edit",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function ali_code(data) {
    return request({
      url: "/ali_code_pay.Orderpay/topay",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
 
  export function get_openid(data) {
    return request({
      url: "/wx_jsapi.Orderpay/get_openid",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function wxpccode(data) {
    return request({
      url: "/wx_code_pay.Orderpay/topay",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
    
  }
  export function wxwebcode(data) {
    return request({
      url: "/wxpay.Orderpay/topay",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
    
  }
  export function wx_code(data) {
    return request({
      url: "/wx_jsapi.Orderpay/topay",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
    
  }
  export function alipay(data) {
    return request({
      url: "/alipay.Orderpay/topay",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function order_add(data) {
    return request({
      url: "/order.Order/order_add",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function cart_pay(data) {
    return request({
      url: "/order.Order/cart_pay",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function ExchangeOrder(data) {
    return request({
      url: "/user.ExchangeOrder/order_add",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }
  export function upload(data) {
    return request({
      url: "admin/Upload/upload",  //接口路径
      method: "post",  //接口方法
      data,//给接口添加请求头
      //接口参数
    });
  }


// WEBPACK FOOTER //
// ./src/request/api.js